import HttpStatus from 'components/Common/HttpStatus'
import Error404Page from 'components/Pages/Error404Page'
import loadable from '@loadable/component'
import { LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP, LE_AGENT_HUB_SOCIETE_CONFIRMATION } from './AgentHubRoutes'
import AuthRoute from 'components/App/Routes/AuthRoute'
import LocaleAwareRoute, { LocaleAwareSwitch } from 'components/App/Routes/LocaleAwareRoute'

const AgentHubLandingPage = loadable(() => import('agentHub/pages/landing/AgentHubLandingPage'))
const AgentHubCompleteAccountSetup = loadable(() => import('agentHub/pages/AgentHubAccountSetup/AgentHubCompleteAccountSetupPage'))
const SocieteConfirmationPage = loadable(() => import('agentHub/pages/SocieteConfirmationPage'))
const ResetPasswordPage = loadable(() => import('components/Pages/ResetPasswordPage/ResetPasswordPage'))

function AgentHubGuestPageRoutes() {
  return <LocaleAwareSwitch>
    <LocaleAwareRoute path="/:regionCode">
      <LocaleAwareSwitch>
        <LocaleAwareRoute exact path="/:regionCode" component={AgentHubLandingPage} />
        <LocaleAwareRoute exact path={`/:regionCode${LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP}`} component={AgentHubCompleteAccountSetup} />
        <LocaleAwareRoute exact path={`/:regionCode${LE_AGENT_HUB_SOCIETE_CONFIRMATION}`} component={SocieteConfirmationPage} />
        <LocaleAwareRoute exact path="/:regionCode/reset-password/:resetPasswordToken" component={ResetPasswordPage} />

        <AuthRoute showPopup />
      </LocaleAwareSwitch>
    </LocaleAwareRoute>
    {/*
      Code below will match all non-declared routes
      It will also stop all routes loaded after it from rendering
      if your route isn't rendering on agent hub, make sure it
      is loaded before this component
    */}
    <LocaleAwareRoute>
      <HttpStatus code={404}>
        <Error404Page />
      </HttpStatus>
    </LocaleAwareRoute>
  </LocaleAwareSwitch>
}

export default AgentHubGuestPageRoutes
